import PropTypes from 'prop-types';
// @mui
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';
// auth
import { useAuthContext } from 'src/auth/hooks';
// routes
import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// theme
import { bgGradient } from 'src/theme/css';
// components
import Logo from 'src/components/logo';
import { secondaryFont } from 'src/theme/typography';

// ----------------------------------------------------------------------

export default function AuthClassicLayout({ children, image, title }) {
  const { method } = useAuthContext();

  const theme = useTheme();

  const upMd = useResponsive('up', 'md');

  const renderLogo = (
    <Logo
      variant="light"
      sx={{
        position: 'absolute',
        top: 10,
        left: 12,
      }}
    />
  );

  const renderSection = (
    <Stack
      width="50%"
      alignItems="center"
      justifyContent="center"
      bgcolor="#000000"
    >
      <Stack position="relative" height="100%">
        <div
          style={{
            backgroundColor: 'black',
            height: '100vh',
            width: '50vw',
            display: 'flex',
            justifyContent: 'around',
            alignItems: 'center',
            flexDirection: 'column',
            padding: '3rem',
          }}
        >
          <div style={{ alignSelf: 'start' }}>
            <h1
              style={{
                fontFamily: 'vietnamPro-extra-lg, sans-serif',
                color: '#ffffff',
                fontSize: '44px',
                fontWeight: '700',
                marginBottom: '10px',
              }}
            >
              Welcome !!
            </h1>
            <p
              style={{
                fontFamily: 'vietnamPro-extra-lg, sans-serif',
                color: 'darkgray',
                fontSize: '18px',
                fontWeight: '500',
                marginTop: '0px',
              }}
            >
              Your all-in-one hiring platform to screen, interview, and hire
              candidates.
            </p>
          </div>
          <div className="image">
            <img
              className="img-fluid"
              src="https://cf-hireintel-download.hireintel.app/web-images/signup1.webp"
              style={{ height: '60vh' }}
            />
          </div>
        </div>
      </Stack>
    </Stack>
  );

  const renderContent = (
    <Stack
      flexGrow={1}
      width="50%"
      position="relative"
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: '#ffffff',
        backdropFilter: 'blur(15px)',
      }}
    >
      <Stack
        alignItems="center"
        spacing={3}
        height="30rem"
        sx={{
          bgcolor: 'transparent',
          borderRadius: '1.25rem',
          backdropFilter: 'blur(11.76998233795166px)',
        }}
        mt={8}
      >
        {children}
      </Stack>
      <Typography
        position="absolute"
        bottom={10}
        variant="caption"
        color="#212121"
      >
        &copy; Copyright {new Date().getFullYear()}{' '}
        <Link color="#5418ef" underline="always" href="https://hireintel.app">
          Hireintel
        </Link>
        . All rights reserved.
      </Typography>
    </Stack>
  );

  return (
    <Stack
      direction="row"
      sx={{
        height: '100%',
        background: '#000000',
      }}
    >
      {/* {renderLogo} */}

      {upMd && renderSection}

      {renderContent}
    </Stack>
  );
}

AuthClassicLayout.propTypes = {
  children: PropTypes.node,
  image: PropTypes.string,
  title: PropTypes.string,
};
